// extracted by mini-css-extract-plugin
module.exports = {"container":"products_container__1RTbN","filter":"products_filter__1g7mH","sort":"products_sort__Gs9Ln","productList":"products_productList__374LF"};